import React, { useState } from 'react';
import '../styles/BubbleButton.css';

import firmaydescarga from '../assets/firmaydescarga.png';
import descargar from '../assets/descarga.png';
import validar from '../assets/validar.png';
import reclamo from '../assets/reclamar.png';
import verReclamo from '../assets/verrespuesta.png';

const BubbleButton = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            {/* Botón flotante */}
            <button className="bubble-button" onClick={() => setIsOpen(true)}>?</button>

            {/* Modal */}
            {isOpen && (
                <div className="bubble-modal-overlay" onClick={() => setIsOpen(false)}>
                    <div className="bubble-modal-content" onClick={e => e.stopPropagation()}>
                        <span className="close" onClick={() => setIsOpen(false)}>&times;</span>

                        <div className="modal-body">
                            <h3>Instructivo de funciones de los botones</h3>

                            <div className="infoText">
                                <img src={firmaydescarga} className="infoText_img" alt="" />
                                <p>
                                    <strong>Firmar y descargar recibo</strong> (botón oscuro).
                                    Este botón permite firmar digitalmente el recibo y descargarlo en el mismo paso.
                                </p>
                            </div>

                            <div className="infoText">
                                <img src={descargar} className="infoText_img" alt="" />
                                <p>
                                    <strong>Descargar recibo firmado</strong> (botón gris claro).
                                    Si el recibo ya fue firmado previamente, este botón permite descargarlo directamente.
                                </p>
                            </div>

                            <div className="infoText">
                                <img src={validar} className="infoText_img" alt="" />
                                <p>
                                    <strong>Validar recibo</strong> (botón verde con tilde).
                                    Este botón permite validar definitivamente el recibo una vez revisado.
                                </p>
                            </div>

                            <div className="infoText">
                                <img src={reclamo} className="infoText_img" alt="" />
                                <p>
                                    <strong>Realizar reclamo</strong> (botón amarillo).
                                    Permite iniciar un reclamo si encontrás alguna diferencia o error en el recibo.
                                </p>
                            </div>

                            <div className="infoText">
                                <img src={verReclamo} className="infoText_img" alt="" />
                                <p>
                                    <strong>Ver respuesta de RRHH</strong> (botón naranja con ojo).
                                    Te permite ver la resolución del reclamo si realizaste uno.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default BubbleButton;
